import React from 'react';
import { Info } from 'lucide-react';

interface KeyTakeawayProps {
  children: React.ReactNode;
  icon?: React.ReactNode;
  title?: string;
  variant?: 'default' | 'success' | 'warning';
}

/**
 * A standardized key takeaway component for highlighting important information
 */
const KeyTakeaway: React.FC<KeyTakeawayProps> = ({ 
  children, 
  icon = <Info className="h-5 w-5" />,
  title = 'Key Takeaway',
  variant = 'default'
}) => {
  const variants = {
    default: {
      bg: 'bg-blue-50',
      border: 'border-blue-500',
      title: 'text-blue-800',
      content: 'text-blue-700'
    },
    success: {
      bg: 'bg-green-50',
      border: 'border-green-500',
      title: 'text-green-800',
      content: 'text-green-700'
    },
    warning: {
      bg: 'bg-amber-50',
      border: 'border-amber-500',
      title: 'text-amber-800',
      content: 'text-amber-700'
    }
  };

  const styles = variants[variant];

  return (
    <div className={`${styles.bg} border-l-4 ${styles.border} p-4 my-6 rounded-r-md`}>
      <div className="flex items-center gap-2 mb-2">
        <span className={styles.title}>{icon}</span>
        <h4 className={`text-lg font-semibold ${styles.title}`}>{title}</h4>
      </div>
      <div className={styles.content}>
        {children}
      </div>
    </div>
  );
};

export default KeyTakeaway;